<template>
  <div class="col-11 pl-0 ml-0">
    <v-row>
      <v-col cols="6">
        <p class="title pl-0 ml-0 mt-5">쇼핑몰 노출 - 안내 문구 설정</p>
        <p class="mb-0 subtitle-2 font-weight-medium pl-0">생성된 쇼핑몰 정품 인증 페이지 하단에 노출되는 문구를 설정 가능합니다.</p>
        <p class="mb-0 subtitle-2 font-weight-medium pl-0">정품 인증 관련 안내가 필요한 경우 입력하여 사용해주세요.</p>
        <p
          class="mb-0 subtitle-2 font-weight-medium pl-0 pb-2"
        >* 정품인증하기 / 정품인증내역 - 탭 메뉴를 클릭하여 각 페이지별 안내 문구 설정이 가능합니다.</p>
        <p
          class="mb-0 subtitle-2 font-weight-medium pl-0 pt-2"
        >저장 후 '쇼핑몰 화면보기' 버튼을 클릭하시면 내 쇼핑몰 정품 인증 페이지에 반영된 모습을 확인 가능합니다.</p>
        <p class="mb-0 subtitle-2 font-weight-medium pl-0">PC와 모바일 화면을 만들어주셔야 정상적으로 이동하오니 참고해주세요.</p>

        <v-col class="pl-0 ml-0 pb-0">
          <!-- Tab links -->
          <div class="tab">
            <div class="tabInfo" v-bind:class="{ auth: isAuthHideen }">
              <button class="tablinks" @click="tabOpen('auth')" :style="authTabStyle">정품 인증 하기</button>
            </div>
            <div class="tabArea"></div>
            <div class="tabInfo" v-bind:class="{ auth: isAuthListHideen } ">
              <button
                class="tablinks"
                @click="tabOpen('authList')"
                :style="authTabListStyle"
              >정품 인증 내역</button>
            </div>
          </div>
          <!-- Tab content -->
          <div id="auth" class="content" v-if="isAuthHideen == true">
            <div>
              <h3 style="font-size:30px;">정품인증</h3>
              <p class="font1 mb-0" style="font-size:16px;">정품 시리얼 코드를 등록해주세요.</p>
              <p class="font1 mb-0" style="font-size:16px;">다양한 혜택을 받으실 수 있습니다</p>
            </div>

            <div id="btn_group">
              <button style="height: 38px; font-size:14px;cursor:default; outline:0">인증하기</button>
            </div>

            <div class="footer-text" align="center">
              <v-textarea
                outlined
                name="text"
                placeholder="어드민에서 운영자가 입력한 안내 문구입니다.        자유롭게 입력 가능합니다."
                single-line
                no-resize
                v-model="description"
                :value="description"
                style="width: 80%;"
                align="center"
                id="description"
              ></v-textarea>
            </div>
          </div>

          <div id="authList" class="content" v-else>
            <div>
              <h3 style="font-size:30px;">정품인증내역</h3>
              <p class="font1 mb-0" style="font-size:16px;">인증되신 상품의 내역 확인이 가능하며</p>
              <p class="font1 mb-6" style="font-size:16px;">분실/인증취소 관리를 할 수 있습니다.</p>
            </div>
            <div class="authInfoList" id="authInfoList">
              <div class="authInfo content">
                <div class="authContents">
                  <div>
                    <img
                      id="image"
                      src="http://static.hubzum.zumst.com/hubzum/2018/06/04/09/f0b77386d1eb49d68dc054a44cd72161.jpg"
                      style="float: left;margin-right: 20px;clear: both;width: 80px;height: 80px;"
                      class="mt-0"
                    />
                  </div>
                  <div style="display: grid;padding-left: 5px;">
                    <p
                      class="authInfoText textBold mb-0"
                      id="authCodeInfo"
                    >정품코드 : P910-9D92-2020-22A1</p>
                    <p class="authInfoText textBold mb-0">보증기간 : 2020.04.05 ~ 2021.04.05</p>
                    <p class="authInfoText mb-0" id="produnctInfo">상품명 : 테스트 상품</p>
                    <p class="authInfoText mb-0" id="authState">
                      인증 상태 :
                      <font class="textBold">정상</font>
                    </p>
                  </div>
                </div>
                <div style="width:100%;">
                  <button
                    class="authCancelhBtn"
                    style="height: 38px; font-size:14px;cursor:default;outline:0"
                  >인증 취소</button>
                  <button
                    class="authBtn"
                    style="height: 38px; font-size:14px;cursor:default;outline:0"
                  >분실 등록</button>
                </div>
              </div>
            </div>
            <div class="footer-text" align="center">
              <v-textarea
                outlined
                name="text"
                placeholder="어드민에서 운영자가 입력한 안내 문구입니다.        자유롭게 입력 가능합니다."
                single-line
                no-resize
                style="width:100%;"
                v-model="information"
                :value="information"
              ></v-textarea>
            </div>
          </div>
        </v-col>
        <div align="center">
          <v-col cols="12" align="center" style="max-width:640px;">
            <v-row align="center">
              <v-col class="pl-0 pt-0" align="center">
                <v-btn
                  class="ma-2"
                  color="primary"
                  @click="descriptionSave()"
                  large
                  style="width:100%"
                >저장</v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col align="center" class="pa-0">
                <v-btn
                  color="green"
                  dark
                  @click="openPopup('p')"
                  large
                  width="49%"
                  style="max-width:310px;"
                >PC 쇼핑몰 화면보기</v-btn>
                <v-btn
                  color="green"
                  dark
                  width="49%"
                  @click="openPopup('m')"
                  large
                  class="ml-1"
                  style="max-width:320px;"
                >모바일 쇼핑몰 화면보기</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-col>
    </v-row>
  </div>
</template>





<style src="../../../../public/authservice/etc/userfront/src/css/index.css"></style>
<style  src="../../../../public/authservice/etc/userfront/src/css/authList.css"></style>

<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../store";
export default {
  data() {
    return {
      AUTH_SERVICE,
      description: "",
      information: "",
      isAuthHideen: true,
      isAuthListHideen: false,
      authTabStyle: "color:#404040;font-size:18px;",
      authTabListStyle: "color: #eaeaea;",
      url: store.state.mallId + ".cafe24.com/royalty.html"
    };
  },
  components: {},
  mixins: [CommonMixin],
  methods: {
    tabOpen: function(value) {
      if (value == "auth") {
        this.isAuthHideen = true;
        this.isAuthListHideen = false;
        this.authTabStyle = "color:#404040;";
        this.authTabListStyle = "color: #eaeaea;";
      } else {
        this.isAuthHideen = false;
        this.isAuthListHideen = true;
        this.authTabStyle = "color: #eaeaea;";
        this.authTabListStyle = "color: #404040;";
      }
    },
    descriptionSave: async function() {
      if (this.description.length > 280) {
        this.alertShow(
          "글자가 너무 많습니다. \r\n280글자 이내로 작성해주세요."
        );
        return false;
      }
      //전송 파라메터
      let putParams = {
        description: this.description,
        information: this.information
      };
      let data = await M.api(M.entry("/put/description"), putParams);
      if (data) {
        this.alertShow("저장되었습니다.");
      }
    },

    openPopup: function(type) {
      let moveUrl = "";
      let params = "";
      if (this.isAuthHideen === true) {
        params =
          "?view=1&description=" +
          this.description.replace(/(\n|\r\n)/g, "<br>") +
          "&information=" +
          this.information.replace(/(\n|\r\n)/g, "<br>");
      } else {
        params =
          "?view=2&description=" +
          this.description.replace(/(\n|\r\n)/g, "<br>") +
          "&information=" +
          this.information.replace(/(\n|\r\n)/g, "<br>");
      }
      if (type == "m") {
        moveUrl = "http://m." + this.url;
        window.open(moveUrl + params, "mobile", "width=420,height=800");
      } else {
        moveUrl = "http://" + this.url;
        window.open(moveUrl + params);
      }
    }
  },

  created: async function() {
    try {
      let data = await M.api(M.entry("/get/description"), {});
      this.description = data.description;
      this.information = data.information;
    } catch (e) {
      //console.log(e);
    }
  }
};
</script>